import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Gauge, Building2, Factory, Wifi, Wrench, ChevronDown, ChevronUp } from 'lucide-react';
import SEO from '../components/SEO';

const Metering = () => {
  const [openFaqIndex, setOpenFaqIndex] = React.useState(null);

  // Full 73 areas: UK + England + Wales + 48 English counties + 22 Welsh areas
  const areaServed = [
    { "@type": "Country", "name": "United Kingdom" },
    { "@type": "AdministrativeArea", "name": "England" },
    { "@type": "AdministrativeArea", "name": "Wales" },
    { "@type": "AdministrativeArea", "name": "Bedfordshire" },
    { "@type": "AdministrativeArea", "name": "Berkshire" },
    { "@type": "AdministrativeArea", "name": "Bristol" },
    { "@type": "AdministrativeArea", "name": "Buckinghamshire" },
    { "@type": "AdministrativeArea", "name": "Cambridgeshire" },
    { "@type": "AdministrativeArea", "name": "Cheshire" },
    { "@type": "AdministrativeArea", "name": "City of London" },
    { "@type": "AdministrativeArea", "name": "Cornwall" },
    { "@type": "AdministrativeArea", "name": "Cumbria" },
    { "@type": "AdministrativeArea", "name": "Derbyshire" },
    { "@type": "AdministrativeArea", "name": "Devon" },
    { "@type": "AdministrativeArea", "name": "Dorset" },
    { "@type": "AdministrativeArea", "name": "County Durham" },
    { "@type": "AdministrativeArea", "name": "East Riding of Yorkshire" },
    { "@type": "AdministrativeArea", "name": "East Sussex" },
    { "@type": "AdministrativeArea", "name": "Essex" },
    { "@type": "AdministrativeArea", "name": "Gloucestershire" },
    { "@type": "AdministrativeArea", "name": "Greater London" },
    { "@type": "AdministrativeArea", "name": "Greater Manchester" },
    { "@type": "AdministrativeArea", "name": "Hampshire" },
    { "@type": "AdministrativeArea", "name": "Herefordshire" },
    { "@type": "AdministrativeArea", "name": "Hertfordshire" },
    { "@type": "AdministrativeArea", "name": "Isle of Wight" },
    { "@type": "AdministrativeArea", "name": "Kent" },
    { "@type": "AdministrativeArea", "name": "Lancashire" },
    { "@type": "AdministrativeArea", "name": "Leicestershire" },
    { "@type": "AdministrativeArea", "name": "Lincolnshire" },
    { "@type": "AdministrativeArea", "name": "Merseyside" },
    { "@type": "AdministrativeArea", "name": "Norfolk" },
    { "@type": "AdministrativeArea", "name": "North Yorkshire" },
    { "@type": "AdministrativeArea", "name": "Northamptonshire" },
    { "@type": "AdministrativeArea", "name": "Northumberland" },
    { "@type": "AdministrativeArea", "name": "Nottinghamshire" },
    { "@type": "AdministrativeArea", "name": "Oxfordshire" },
    { "@type": "AdministrativeArea", "name": "Rutland" },
    { "@type": "AdministrativeArea", "name": "Shropshire" },
    { "@type": "AdministrativeArea", "name": "Somerset" },
    { "@type": "AdministrativeArea", "name": "South Yorkshire" },
    { "@type": "AdministrativeArea", "name": "Staffordshire" },
    { "@type": "AdministrativeArea", "name": "Suffolk" },
    { "@type": "AdministrativeArea", "name": "Surrey" },
    { "@type": "AdministrativeArea", "name": "Tyne and Wear" },
    { "@type": "AdministrativeArea", "name": "Warwickshire" },
    { "@type": "AdministrativeArea", "name": "West Midlands" },
    { "@type": "AdministrativeArea", "name": "West Sussex" },
    { "@type": "AdministrativeArea", "name": "West Yorkshire" },
    { "@type": "AdministrativeArea", "name": "Wiltshire" },
    { "@type": "AdministrativeArea", "name": "Worcestershire" },
    { "@type": "AdministrativeArea", "name": "Blaenau Gwent" },
    { "@type": "AdministrativeArea", "name": "Bridgend" },
    { "@type": "AdministrativeArea", "name": "Caerphilly" },
    { "@type": "AdministrativeArea", "name": "Cardiff" },
    { "@type": "AdministrativeArea", "name": "Carmarthenshire" },
    { "@type": "AdministrativeArea", "name": "Ceredigion" },
    { "@type": "AdministrativeArea", "name": "Conwy" },
    { "@type": "AdministrativeArea", "name": "Denbighshire" },
    { "@type": "AdministrativeArea", "name": "Flintshire" },
    { "@type": "AdministrativeArea", "name": "Gwynedd" },
    { "@type": "AdministrativeArea", "name": "Isle of Anglesey" },
    { "@type": "AdministrativeArea", "name": "Merthyr Tydfil" },
    { "@type": "AdministrativeArea", "name": "Monmouthshire" },
    { "@type": "AdministrativeArea", "name": "Neath Port Talbot" },
    { "@type": "AdministrativeArea", "name": "Newport" },
    { "@type": "AdministrativeArea", "name": "Pembrokeshire" },
    { "@type": "AdministrativeArea", "name": "Powys" },
    { "@type": "AdministrativeArea", "name": "Rhondda Cynon Taf" },
    { "@type": "AdministrativeArea", "name": "Swansea" },
    { "@type": "AdministrativeArea", "name": "Torfaen" },
    { "@type": "AdministrativeArea", "name": "Vale of Glamorgan" },
    { "@type": "AdministrativeArea", "name": "Wrexham" }
  ];

  const counties = [
    "Bedfordshire", "Berkshire", "Bristol", "Buckinghamshire", "Cambridgeshire", "Cheshire", "City of London", "Cornwall", "Cumbria", "Derbyshire", "Devon", "Dorset", "County Durham", "East Riding of Yorkshire", "East Sussex", "Essex", "Gloucestershire", "Greater London", "Greater Manchester", "Hampshire", "Herefordshire", "Hertfordshire", "Isle of Wight", "Kent", "Lancashire", "Leicestershire", "Lincolnshire", "Merseyside", "Norfolk", "North Yorkshire", "Northamptonshire", "Northumberland", "Nottinghamshire", "Oxfordshire", "Rutland", "Shropshire", "Somerset", "South Yorkshire", "Staffordshire", "Suffolk", "Surrey", "Tyne and Wear", "Warwickshire", "West Midlands", "West Sussex", "West Yorkshire", "Wiltshire", "Worcestershire",
    "Blaenau Gwent", "Bridgend", "Caerphilly", "Cardiff", "Carmarthenshire", "Ceredigion", "Conwy", "Denbighshire", "Flintshire", "Gwynedd", "Isle of Anglesey", "Merthyr Tydfil", "Monmouthshire", "Neath Port Talbot", "Newport", "Pembrokeshire", "Powys", "Rhondda Cynon Taf", "Swansea", "Torfaen", "Vale of Glamorgan", "Wrexham"
  ];

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Gas Metering",
    "serviceType": "Gas Meter Installation",
    "description": "Commercial and industrial gas meter installation, AMR metering, meter asset management and maintenance across England and Wales, delivered by Green Frog Asset Management, a MAM and AMI accredited metering company in the Green Frog Utilities group.",
    "provider": {
      "@type": "Organization",
      "name": "Green Frog Asset Management",
      "url": "https://greenfrogassetmanagement.co.uk",
      "parentOrganization": {
        "@type": "Organization",
        "name": "Green Frog Utilities",
        "url": "https://greenfrogutilities.co.uk"
      }
    },
    "hasCredential": [
      { "@type": "EducationalOccupationalCredential", "name": "MAM, Meter Asset Manager" },
      { "@type": "EducationalOccupationalCredential", "name": "AMI, Approved Meter Installer" }
    ],
    "areaServed": areaServed,
    "url": "https://greenfrogutilities.co.uk/metering"
  };

  const faqData = [
    {
      question: "Do you install commercial gas meters across the UK?",
      answer: "Yes. Green Frog installs commercial and industrial gas meters across England and Wales, from the Midlands base in Tamworth, with the installation carried out by Green Frog Asset Management under its MAM and AMI accreditation."
    },
    {
      question: "What size or type of gas meter does my site need?",
      answer: "It depends on the load and pressure of the connection. Commercial sites typically use rotary, turbine, diaphragm or ultrasonic meters, and the type is agreed at the design stage so the meter matches the connection rather than being sized afterwards."
    },
    {
      question: "Is an AMR meter the same as a submetering system?",
      answer: "Not quite. AMR, or automated meter reading, sends readings out from the meter automatically. A submetering system goes further and allows you to monitor individual circuits or zones within a building. Green Frog Asset Management installs both, with remote monitoring over LoRaWAN where the site needs it."
    },
    {
      question: "What does a Meter Asset Manager actually do?",
      answer: "The MAM installs, owns, maintains and keeps the records for the meter over its life, and deals with the supplier and network on the site's behalf. With Green Frog Utilities the MAM is part of the same group that laid the connection."
    },
    {
      question: "Can you do the gas connection and the meter as one job?",
      answer: "Yes. That is the reason the group is set up the way it is. Green Frog Utilities delivers the connection under GIRS and Green Frog Asset Management installs and manages the meter, so there is one programme and one point of contact."
    }
  ];

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://greenfrogutilities.co.uk/" },
      { "@type": "ListItem", "position": 2, "name": "Services", "item": "https://greenfrogutilities.co.uk/metering" },
      { "@type": "ListItem", "position": 3, "name": "Gas Metering", "item": "https://greenfrogutilities.co.uk/metering" }
    ]
  };

  const meterTypes = [
    {
      icon: Building2,
      title: "Commercial gas meters",
      desc: "Rotary, turbine, diaphragm and ultrasonic meters with pressure regulation and capacity sizing for shops, offices, restaurants, schools and mixed use buildings."
    },
    {
      icon: Factory,
      title: "Industrial gas meters",
      desc: "High capacity metering for factories, manufacturing plants, process sites and large industrial estates."
    },
    {
      icon: Wifi,
      title: "AMR metering",
      desc: "Automated meter reading, smart and telemetry systems with remote monitoring over LoRaWAN in partnership with Netmore, plus AI bill validation."
    },
    {
      icon: Wrench,
      title: "Maintenance and compliance",
      desc: "Meter maintenance, upgrades and compliance with UK gas metering standards for the life of the asset."
    }
  ];

  const processSteps = [
    { step: "1", title: "Design and sizing", desc: "Load, pressure and meter type agreed with the connection design, not after it." },
    { step: "2", title: "Connection", desc: "Mains and service laid by Green Frog Utilities under GIRS." },
    { step: "3", title: "Meter installation", desc: "Fitted by Green Frog Asset Management under its AMI accreditation." },
    { step: "4", title: "Registration and reading", desc: "Meter registered, AMR or smart reading set up where specified, records held by the MAM." },
    { step: "5", title: "Ongoing management", desc: "Maintenance, compliance and any upgrade handled by the same company that installed it." }
  ];

  const toggleFaq = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  return (
    <div>
      <SEO 
        title="Gas Metering | MAM and AMI Accredited Meter Installers | Green Frog Utilities"
        description="Commercial and industrial gas meter installation across England and Wales from Green Frog Utilities. MAM and AMI accredited, rotary, turbine, diaphragm and ultrasonic meters, AMR metering, delivered by our metering company Green Frog Asset Management."
        canonical="/metering"
        jsonLd={[serviceSchema, faqSchema, breadcrumbSchema]}
      />

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-emerald-600 to-emerald-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <div className="flex justify-center mb-6">
              <Gauge className="h-16 w-16" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Gas Metering
            </h1>
            <p className="text-xl text-emerald-100 max-w-4xl mx-auto leading-relaxed mb-8">
              Commercial and industrial gas meter installation, delivered through Green Frog Asset Management, our MAM and AMI accredited metering company.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/contact">
                <Button size="lg" className="bg-white text-emerald-700 hover:bg-emerald-50">
                  Get a Quote
                </Button>
              </Link>
              <a href="https://greenfrogassetmanagement.co.uk">
                <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-emerald-700">
                  Visit Green Frog Asset Management
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Group Link */}
      <section className="py-4 bg-emerald-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Link to="/green-frog-group" className="text-emerald-700 hover:text-emerald-800 font-medium">
            How Green Frog Utilities and Green Frog Asset Management work together &rarr;
          </Link>
        </div>
      </section>

      {/* Why Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Metering is the part of the job most contractors hand to someone else
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed">
              A new gas connection is not finished until the meter is in, sized correctly, registered and reading. Most utility contractors lay the pipe and leave the meter to a third party, which means a second company, a second programme and a second point of failure. Green Frog Utilities keeps it inside the two companies. The connection is delivered by Green Frog Utilities under GIRS, and the meter is installed, owned and managed by Green Frog Asset Management, our own MAM and AMI accredited metering company.
            </p>
          </div>
        </div>
      </section>

      {/* What We Install Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            What we install
          </h2>
          <p className="text-gray-600 text-lg mb-8">
            Every meter type used on commercial and industrial sites, sized to the load and pressure of the connection.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {meterTypes.map((meter, index) => (
              <Card key={index} className="border-none hover:shadow-lg transition-shadow">
                <CardContent className="p-6">
                  <div className="flex items-start gap-4">
                    <div className="bg-emerald-100 p-3 rounded-lg">
                      <meter.icon className="h-6 w-6 text-emerald-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-2">{meter.title}</h3>
                      <p className="text-gray-600">{meter.desc}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* MAM Explained Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Meter Asset Management, explained in plain terms
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed">
              A Meter Asset Manager, or MAM, is the accredited company responsible for a gas meter across its whole life: installing it, owning it, maintaining it and keeping its records correct with the supplier. An Approved Meter Installer, or AMI, is the accreditation that allows a company to fit meters on the network. Green Frog Asset Management holds both. In practice that means one accountable company for the meter, no arguments between installer and owner, and a single point of contact when the supplier, the network or the site needs something changed.
            </p>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-emerald-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              How a metered connection runs with Green Frog Utilities
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
            {processSteps.map((phase, index) => (
              <div key={index} className="text-center">
                <div className="text-5xl font-bold text-emerald-300 mb-4">{phase.step}</div>
                <h3 className="text-xl font-bold mb-2">{phase.title}</h3>
                <p className="text-emerald-100">{phase.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
            Frequently asked questions
          </h2>
          <div className="space-y-4">
            {faqData.map((faq, index) => (
              <div 
                key={index}
                className="border border-gray-200 rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full flex items-center justify-between p-6 text-left bg-white hover:bg-gray-50 transition-colors"
                >
                  <span className="text-lg font-semibold text-gray-900 pr-4">
                    {faq.question}
                  </span>
                  {openFaqIndex === index ? (
                    <ChevronUp className="h-5 w-5 text-emerald-600 flex-shrink-0" />
                  ) : (
                    <ChevronDown className="h-5 w-5 text-emerald-600 flex-shrink-0" />
                  )}
                </button>
                {openFaqIndex === index && (
                  <div className="px-6 pb-6 bg-white">
                    <p className="text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Where We Work Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Where we work</h2>
          <p className="text-gray-600 mb-6">
            Green Frog Utilities delivers gas, water and electrical connections across England and Wales, from a single accredited contractor.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-1">
            {counties.map((county, index) => (
              <span key={index} className="text-sm text-gray-500">{county}</span>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-emerald-50 to-emerald-100 rounded-2xl p-12 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Talk to us about metering
            </h2>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              One group for the connection and the meter.
            </p>
            <Link to="/contact">
              <Button size="lg" className="bg-emerald-600 hover:bg-emerald-700 text-white">
                Get a Quote
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Metering;
